//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import LanguageSelectorMixin from "../../../shared/mixins/language-selector-mixin";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "LangSelector",
  mixins: [LanguageSelectorMixin],
  props: {
    defaultStyles: {
      type: Boolean,
      default: false
    },
    withConfirmation: {
      type: Boolean,
      default: true
    },
    localeModel: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      activateLocales: false
    };
  }
});